import { Flex } from 'antd';
import {
	PhoneOutlined,
	MailOutlined,
	CrownOutlined,
	ShopOutlined,
} from '@ant-design/icons';
import { isEmpty } from 'lodash';
import ProspectInfoBox from './prospectInfoBox';

type ProspectInfoFieldType<T> = {
	/**
	 * if there are request in-flight
	 */
	isLoading: boolean;
	/**
	 * Field's update handler
	 * @param value
	 */
	onUpdate: (value: T) => void;
	/**
	 * Field's value
	 */
	value: T;
};

/**
 * Props for the Prospect Info panel.
 */
interface ProspectInfoProps {
	/**
	 * The contact's title.
	 */
	contactTitle: ProspectInfoFieldType<string>;
	/**
	 * The contact's company.
	 */
	contactCompany: ProspectInfoFieldType<string>;
	/**
	 * The contact's email.
	 */
	contactEmail: ProspectInfoFieldType<string>;
	/**
	 * The contact's phone number.
	 */
	contactPhoneNumber: ProspectInfoFieldType<string>;
}

/**
 * The Prospect Info panel.
 * @param props
 * @constructor
 */
export default function ProspectInfo(props: ProspectInfoProps) {
	return (
		<Flex vertical gap={'small'}>
			<ProspectInfoBox
				icon={<ShopOutlined />}
				placeholder="Enter company"
				text={
					!isEmpty(props.contactCompany.value)
						? props.contactCompany.value
						: undefined
				}
				isLoading={props.contactCompany.isLoading}
				onUpdate={props.contactCompany.onUpdate}
			/>
			<ProspectInfoBox
				icon={<CrownOutlined />}
				placeholder="Enter title"
				text={!isEmpty(props.contactTitle.value) ? props.contactTitle.value : undefined}
				isLoading={props.contactTitle.isLoading}
				onUpdate={props.contactTitle.onUpdate}
			/>
			<ProspectInfoBox
				icon={<MailOutlined />}
				placeholder="Enter email"
				text={!isEmpty(props.contactEmail.value) ? props.contactEmail.value : undefined}
				isLoading={props.contactEmail.isLoading}
				onUpdate={props.contactEmail.onUpdate}
			/>
			<ProspectInfoBox
				icon={<PhoneOutlined />}
				placeholder="Enter phone number"
				text={
					!isEmpty(props.contactPhoneNumber.value)
						? props.contactPhoneNumber.value
						: undefined
				}
				isLoading={props.contactPhoneNumber.isLoading}
				onUpdate={props.contactPhoneNumber.onUpdate}
			/>
		</Flex>
	);
}
